<template>
  <div class="page">
    <header-title :title="title"></header-title>
    <a-spin :spinning="pageLoading">
      <div class="s-filter-box">
        <a-form layout="inline" :model="filterForm">
          <a-form-item label="Calendar ID">
            <a-auto-complete
              v-model:value="filterForm.cldId"
              :options="searchCldIds"
              style="width: 300px"
              placeholder="Input or Choosing value"
              @search="onSearch"
              @keypress.enter="queryData"
            />
          </a-form-item>
          <a-form-item>
            <a-range-picker v-model:value="filterForm.dateRange" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="queryData">
              <template #icon><SearchOutlined /></template>
              Find
            </a-button>
          </a-form-item>
        </a-form>
        <div class="button-box">
          <div class="btn-a">
            <a-button
              type="primary"
              :loading="addLoading"
              :disabled="!filterForm.cldId"
              @click="addCalendar"
            >
              <template #icon><DiffOutlined /></template>
              Add
            </a-button>

            <a-button danger @click="deleteAll" :disabled="!filterForm.cldId">
              <template #icon><DeleteOutlined /></template>
              Delete
            </a-button>
          </div>
        </div>
      </div>

      <div class="page-body" ref="pageBodyRef">
        <a-table
          :columns="columns"
          :row-key="(record) => record.id"
          :data-source="currentDatas"
          :loading="loading"
          :pagination="{ defaultPageSize: 20 }"
          :scroll="{ x: '1600', y: tableYHeight }"
          size="small"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <a-button type="link" size="small" @click="openEditModal(record)">
                <template #icon><edit-outlined /></template>
                Edit
              </a-button>
              <a-divider type="vertical" />

              <a-button type="link" size="small" @click="deleteRow(record.id)">
                <template #icon><delete-outlined /></template>
                Delete
              </a-button>
            </template>
          </template>
        </a-table>
      </div>
    </a-spin>
    <a-modal
      v-model:visible="dialogShow"
      width="1000px"
      :title="dialogTitle"
      :confirm-loading="confirmLoading"
      @ok="saveCalendar"
      @cancel="dialogCancel"
    >
      <a-form
        :model="ceForm"
        :rules="rules"
        ref="formRef"
        :label-col="{ span: 8 }"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="Calendar ID" name="cldId">
              <a-input v-model:value="ceForm.cldId" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Item" name="cldItem">
              <a-input v-model:value="ceForm.cldItem" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Time Type" name="timeType">
              <a-select
                v-model:value="ceForm.timeType"
                style="width: 100%"
                placeholder="Please select"
                @change="changeTimeType"
              >
                <a-select-option
                  v-for="item in timeTypes"
                  :key="item.field"
                  :value="item.value"
                >
                  {{ item.field }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Is Work" name="isWork">
              <a-switch v-model:checked="ceForm.isWork"></a-switch>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Shift Number" name="shiftNo">
              <a-input-number
                v-model:value="ceForm.shiftNo"
                style="width: 100%"
                placeholder="Shift Number"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Occurrence" name="occurrence">
              <a-select
                v-model:value="ceForm.occurrence"
                style="width: 100%"
                placeholder="Please select"
                @change="occurrenceChange"
              >
                <a-select-option
                  v-for="item in occurrences"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Start Time" name="startTime">
              <a-date-picker
                show-time
                style="width: 100%"
                valueFormat="YYYY-MM-DD HH:mm"
                v-model:value="ceForm.startTime"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="End Time" name="endTime">
              <a-date-picker
                show-time
                style="width: 100%"
                valueFormat="YYYY-MM-DD HH:mm"
                v-model:value="ceForm.endTime"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Priority" name="priority">
              <a-input
                v-model:value="ceForm.priority"
                placeholder="Input Priority"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'
  import request from '@/utils/request'
  import { mapGetters } from 'vuex'
  import dayjs from 'dayjs'
  import { message, Modal } from 'ant-design-vue'
  import {
    SearchOutlined,
    DiffOutlined,
    EditOutlined,
    DeleteOutlined,
  } from '@ant-design/icons-vue'
  import { throttle } from '@/utils'
  const TimeTypeMap = {
    1: 'regular work time',
    2: 'over time',
    A: 'regular off time',
    B: 'planned equipment maintenance',
    C: 'planned labor off',
  }

  export default {
    components: {
      HeaderTitle,
      SearchOutlined,
      DiffOutlined,
      EditOutlined,
      DeleteOutlined,
    },

    data() {
      return {
        title: 'Calendar',
        loading: false,
        pageLoading: false,
        confirmLoading: false,
        timeTypes: [
          { field: 'regular work time', value: '1' },
          { field: 'over time', value: '2' },
          { field: 'regular off time', value: 'A' },
          { field: 'planned equipment maintenance', value: 'B' },
          { field: 'planned labor off', value: 'C' },
        ],
        occurrences: ['Daily', 'Weekly', 'Once'],
        dialogShow: false,
        tableYHeight: 300,
        dialogTitle: 'Material Group Create',
        addLoading: false,
        cldIds: [],
        searchCldIds: [],
        filterForm: {
          cldId: '',
        },
        sourceTypes: ['Vendor', 'In House'],
        objectIds: [],
        sourceRegionCodes: [],
        ceForm: {
          matGrpId: '',
          materialName: '',
          materialId: '',
          quantity: 1,
          binLocation: '',
          binSeq: 1,
        },
        rules: {
          cldId: [
            {
              required: true,
              message: 'Please Input the cldId',
              trigger: 'blur',
            },
          ],
          cldItem: [
            {
              required: true,
              message: 'Please Input the Item',
              trigger: 'blur',
            },
          ],
        },

        currentDatas: [],
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '5%',
          },
          {
            title: 'Calendar ID',
            dataIndex: 'cldId',
            width: '10%',
          },
          {
            title: 'Item',
            dataIndex: 'cldItem',
            width: '8%',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.cldItem * 1 - b.cldItem * 1,
          },
          {
            title: 'Start Time',
            dataIndex: 'startTime',
            width: '15%',
            customRender({ text }) {
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
            },
          },

          {
            title: 'End Time',
            dataIndex: 'endTime',
            width: '15%',
            customRender({ text }) {
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
            },
          },

          {
            title: 'Is Work',
            dataIndex: 'isWork',
            width: '6%',
            customRender({ text }) {
              return text ? 'V' : ''
            },
          },
          {
            title: 'Shift Number',
            dataIndex: 'shiftNo',
            width: '10%',
          },
          {
            title: 'Time Type',
            dataIndex: 'timeType',
            width: '15%',
            customRender({ text }) {
              return TimeTypeMap[text]
            },
          },
          {
            title: 'Priority',
            dataIndex: 'priority',
            width: '8%',
          },
          {
            title: 'Occurrence',
            dataIndex: 'occurrence',
            width: '8%',
          },

          {
            title: 'Operation',
            dataIndex: 'action',
            key: 'action',
            width: '20%',
            fixed: 'right',
          },
        ],
      }
    },
    computed: {
      ...mapGetters({ netGroupId: 'user/currentNetGroup' }),
    },
    created() {
      this.init()
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      occurrenceChange(v) {
        switch (v) {
          case 'Daily':
            this.ceForm.priority = 10
            break
          case 'Weekly':
            this.ceForm.priority = 30
            break
          case 'Once':
            this.ceForm.priority = 50
        }
      },
      changeTimeType(v) {
        this.ceForm.isWork = v === '1' || v === '2'
      },

      setTableScrollH() {
        const obj = this.$refs.pageBodyRef
        if (!obj) return
        const wWidth = document.documentElement.clientWidth
        const tableHeader = document.querySelector('.ant-table-header')
        const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44
        const pagination = document.querySelector(
          '.ant-pagination.ant-table-pagination'
        )
        const pageHeight = pagination ? pagination.clientHeight : 27
        this.tableYHeight =
          obj.clientHeight - tHeadHeight - pageHeight - wWidth * 0.025
      },

      async init() {
        await this.getCldIds()
        const { objectId } = this.$route.query

        this.filterForm.cldId =
          objectId || this.cldIds.length ? this.cldIds[0] : ''
        if (this.filterForm.cldId) {
          this.queryData()
        }
      },
      onSearch(searchText) {
        const f = this.cldIds.filter((item) => {
          return item.indexOf(searchText) !== -1
        })
        this.searchCldIds = f
          ? f.map((item) => {
              return {
                value: item,
              }
            })
          : []
      },
      async getCldIds() {
        const d = await request({
          url: '/api/masterdata/queryCldids',
          method: 'get',
        })

        this.cldIds = d.body
        this.searchCldIds = d.body.map((item) => {
          return {
            value: item,
          }
        })

        return Promise.resolve()
      },

      async queryData() {
        this.loading = true
        const hasDateRange =
          this.filterForm.dateRange && this.filterForm.dateRange.length
        let endTime = hasDateRange
          ? this.filterForm.dateRange[1]
          : '9999-12-31T23:59:59.000Z'
        let startTime = hasDateRange
          ? this.filterForm.dateRange[0]
          : '0000-0-0T00:00:00.000Z'

        let cldId = this.filterForm.cldId || null

        const { body } = await request({
          url: '/api/masterdata/queryCalendar',
          method: 'post',
          data: {
            cldId,
            startTime,
            endTime,
          },
        })
        this.loading = false
        this.currentDatas = body
      },
      // 新增
      async addCalendar() {
        const { cldId } = this.filterForm

        this.ceForm = {
          cldId,
          cldItem: 10,
          startTime: dayjs().format('YYYY-MM-DD HH:mm'),
          endTime: dayjs(dayjs().valueOf() + 60000 - 1).format(
            'YYYY-MM-DD HH:mm'
          ),
          isWork: true,
          shiftNo: 1,
          timeType: 1,
          occurrence: 'Daily',
          priority: 10,
        }
        this.dialogShow = true
        this.dialogTitle = 'Calendar Item Creation'
      },
      // 编辑
      async openEditModal(row) {
        const codes = await this.getRegionCodes()
        const fn = () => {
          const cRow = { ...row }
          cRow.startTime = dayjs(cRow.startTime).format('YYYY-MM-DD HH:mm')
          cRow.endTime = dayjs(cRow.endTime).format('YYYY-MM-DD HH:mm')
          this.ceForm = cRow
          this.dialogShow = true
        }
        if (codes) {
          Modal.confirm({
            title:
              'This calendar has been used for the following regioncode. Do you want to continue changing?',
            content: codes,
            onOk() {
              fn()
            },
          })
        } else {
          fn()
        }
      },
      // 删除
      async deleteRow(id) {
        const _this = this
        Modal.confirm({
          title: `Delete this item?`,
          width: 550,
          async onOk() {
            try {
              const result = await request({
                url: '/api/masterdata/delCalendar',
                method: 'post',
                data: {
                  id,
                },
              })
              if (result.errCode === '0000') {
                message.loading('Deletion succeeded')
                _this.init()
              }
            } catch (e) {
              message.error(e)
            }
          },
        })
      },
      // 删除全部
      async deleteAll() {
        const _this = this
        const { cldId } = this.filterForm
        if (this.cldIds.indexOf(cldId) === -1) {
          message.error(`Calendar ${cldId} does not exist, please check!`)
          return
        }
        const codes = await this.getRegionCodes()
        const fn = async () => {
          const hide = message.loading('Deleting..', 0)
          try {
            const result = await request({
              url: '/api/masterdata/batchdeleteCalendars',
              method: 'post',
              data: {
                cldId,
              },
            })
            if (result.errCode === '0000') {
              _this.init()
            }
            hide()
          } catch (e) {
            hide()
          }
        }
        if (codes) {
          Modal.confirm({
            title:
              'This calendar has been used for the following regioncode. Do you want to continue changing?',
            content: codes,
            onOk() {
              fn()
            },
          })
        } else {
          fn()
        }
      },

      async saveCalendar() {
        const _this = this
        this.$refs.formRef
          .validate()
          .then(async () => {
            _this.save()
          })
          .catch((error) => {
            console.log(error)
          })
      },
      async getRegionCodes() {
        const hide = message.loading('Loading..', 0)
        try {
          const d = await request({
            url: '/api/masterdata/getAllRegionsViaCa',
            method: 'post',
            data: {
              cldId: this.filterForm.cldId,
            },
          })
          hide()
          let regionCodes = d.body.map((item) => {
            return item.regionCode
          })
          return Promise.resolve(regionCodes.join(','))
        } catch (e) {
          hide()
          return Promise.resolve('')
        }
      },
      dialogCancel() {
        this.confirmLoading = false
        this.$refs.formRef.resetFields()
      },
      async save(next = 0) {
        this.confirmLoading = true
        const isEdit = !!this.ceForm.id
        const rawData = { ...this.ceForm }
        rawData.startTime = dayjs(rawData.startTime).valueOf()
        rawData.endTime = dayjs(rawData.endTime).valueOf()
        const url = isEdit
          ? '/api/masterdata/updateCalendar'
          : '/api/masterdata/saveCalendar'
        const d = await request({
          url,
          method: 'post',
          data: rawData,
          nonstandard: true,
        })

        this.confirmLoading = false
        if (d.errCode === '0000') {
          message.success('Save Successful!')
          await this.getCldIds()
          this.queryData()
          if (next === 0) {
            this.dialogShow = false
          }
        } else {
          Modal.error({ title: 'Error', content: d.errMsg })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .page-body {
    height: calc(100vh - 185px);
    overflow: hidden;
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    .button-box {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      margin: 0 -5px;
      .btn-a {
        .ant-btn {
          margin: 0 5px;
        }
      }
    }
  }
</style>
